import type { CreateSessionRequest } from '../../../domain';

/**
 * Pure helpers for the Writer's Lab session lifecycle. Parallels Image Lab's
 * sessionHelpers; kept separate so the lab labels its sessions distinctly.
 */

const SESSION_NAME_FALLBACK = "Writer's Lab session";

const titleCase = (slug: string): string =>
  slug
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');

/**
 * Build a friendly default session name from a studio id. `'storyteller'` →
 * `"Writer's Lab — Storyteller"`; an unknown / empty studio falls back to the
 * generic label. Users can rename via the session API later.
 */
export function buildWriterSessionCreateRequest(studioId: string | undefined): CreateSessionRequest {
  const slug = (studioId ?? '').trim();
  if (!slug) return { name: SESSION_NAME_FALLBACK };
  return {
    name: `Writer's Lab — ${titleCase(slug)}`,
    description: `Auto-created on first operation for studio ${slug}`,
  };
}
